<template>
  <SentimentTimeSeries
    :title="title"
    :item-id="itemId"
    :data-type="dataType"
    :owner-posts="false"
    v-bind="$attrs"
  />
</template>

<script>
import SentimentTimeSeries from '@/components/cards/SentimentTimeSeries';

export default {
  name: 'PropSentimentTimeSeries',
  components: {
    SentimentTimeSeries,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    dataType: {
      type: String,
      default: 'absolute',
    },
  },
};
</script>

<style scoped lang="scss">
</style>
